import { IonRouterLink } from '@ionic/react'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { EmptyPage } from '../../../common/utils/exception/EmptyPage'
import { PagingContent } from '../../../components'
import { DivideLine } from '../../../components/atoms/divide'
import { StoresContext } from '../../../provider/StoreProvider'

export const MainNotification: React.FC = observer(() => {
  const { notificationStore, authStore } = useContext(StoresContext)
  const pagingStore = notificationStore.notificationPagingStore

  useEffect(() => {
    pagingStore.load(undefined, true)
  }, [])

  return (
    <>
      {authStore.userInfo == null ? (
        <EmptyPage icon={'alert-circle-outline'} content={'로그인 후 이용 가능합니다.'} isSignIn={true} />
      ) : (
        <PagingContent pagingStore={pagingStore}>
          {pagingStore.list.map((d, i) => (
            <IonRouterLink
              key={i}
              color={'dark'}
              routerLink={
                d.notificationType === 'CASH_NOTICE'
                  ? `/myPage/account`
                  : d.notificationType === 'CASH_DEPOSIT'
                  ? `/myPage/account`
                  : d.notificationType === 'CASH_WITHDRAWAL'
                  ? `/myPage/account`
                  : d.notificationType === 'QNA_REPLY'
                  ? `/myPage/qna`
                  : d.notificationType === 'USER_INFO_UPDATE'
                  ? `/myPage/setting`
                  : d.notificationType === 'PRODUCT_SALE_NOTICE'
                  ? `/market`
                  : d.notificationType === 'PRODUCT_SALE_UPDATE'
                  ? `/market`
                  : d.notificationType === 'PRODUCT_SALE_CLOSED'
                  ? `/market`
                  : d.notificationType === 'PRODUCT_SALE_PURCHASED'
                  ? `/market`
                  : d.notificationType === 'PRODUCT_SALE_TO_TRADE'
                  ? `/market/${d.extraData.productId}/trade`
                  : d.notificationType === 'PRODUCT_ORDER_RESERVED'
                  ? `/market/${d.extraData.productId}/trade`
                  : d.notificationType === 'PRODUCT_ORDER_FULFILLED'
                  ? `/market/${d.extraData.productId}/trade`
                  : d.notificationType === 'PRODUCT_ORDER_PART_FULFILLED'
                  ? `/market/${d.extraData.productId}/trade`
                  : `/notification/${d.id}/notification`
              }
            >
              <ContentContainer>
                <p className="title">{d.title}</p>
                <p className="content">{d.contents}</p>
                <p className="date">{moment(new Date(d.createdDate)).format('MM월 DD일')}</p>
              </ContentContainer>
              <DivideLine />
            </IonRouterLink>
          ))}
        </PagingContent>
      )}
    </>
  )
})

const ContentContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .title {
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    color: var(--ion-color-primary_light);
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date {
    font-size: 12px;
    font-weight: 400;
    color: var(--ion-color-gray400);
  }
  :hover {
    background-color: var(--ion-color-gray100);
  }
`
